import { BrandId } from '../app/models/brand.model';
import { Benefit } from '../app/models/available-bill-gateway-apps.model';

export const environment = {
  production: false,
  maintenance: false,
  apiPath: '/pay/v1',
  legacyApiPath: '/api',
  poolingInterval: 3000,
  snackBarDurationInSeconds: 5,
  maxCreditCardAmount: 140,
  googleAnalytics: 'UA-122874711-7',
  googleTagManager: 'GTM-N5HDZ4K',
  logRocket: {
    enabled: true,
    appID: 'bt/billtech-pay-test'
  },
  couponAmount: 10,
  commissionAmount: 1.0,
  onlyBalanceBillers: ['MOICO', 'INTERNET_UNION'],
  brands: [
    {
      id: BrandId.BILLTECH,
      host: 'stage.billtech.pl',
      termsOfUseLink: 'https://billtech.pl/legal/billtech_payment_regulamin.pdf',
      privacyPolicyLink: 'https://billtech.pl/legal/billtech_payment_polityka_prywatnosci.pdf',
      contactUsEmail: 'pomoc@billtech.pl',
      footerVisible: true,
      chatEnabled: true,
      isDefault: true
    }
  ],
  cdnAddress: 'https://bill-gateway.stage.billtech.pl',
  billGatewayApps: {
    ALIOR_BANK: {
      code: 'aliorbank',
      displayName: 'Alior Bank',
      redirectLink: {
        desktop: 'https://www.aliorbank.pl/klienci-indywidualni/uslugi/moje-rachunki.html'
      },
      hasInstructions: true,
      benefits: [
        Benefit.NO_COMMISSION,
        Benefit.MULTI_INVOICE_PAYMENTS,
        Benefit.ALL_INVOICES_IN_ONE_PLACE,
        Benefit.PAYMENT_DEFERMENT
      ]
    },
    VELO_BANK: {
      code: 'velobank',
      displayName: 'Velo Bank',
      redirectLink: {
        desktop: 'https://velobank.pl/moje-rachunki'
      },
      hasInstructions: true,
      benefits: [Benefit.NO_COMMISSION, Benefit.ALL_INVOICES_IN_ONE_PLACE]
    },
    MPAY: {
      code: 'mpay',
      displayName: 'mPay',
      redirectLink: {
        desktop: 'https://system.mpay.pl/site/login'
      },
      benefits: [
        Benefit.NO_COMMISSION,
        Benefit.MULTI_INVOICE_PAYMENTS,
        Benefit.ALL_INVOICES_IN_ONE_PLACE,
        Benefit.PAYMENT_DEFERMENT
      ]
    }
  },
  mockWiretransfer: false,
  offlineBanksForTest: []
};
